import { render, staticRenderFns } from "./UpdateIssueForm.vue?vue&type=template&id=527b363a&"
import script from "./UpdateIssueForm.vue?vue&type=script&lang=js&"
export * from "./UpdateIssueForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports